module.exports = {
  PHONE: { api: 'PHONE', human: 'Telefon' },
  EMAIL: { api: 'EMAIL', human: 'E-Mail' },
  POST: { api: 'POST', human: 'Post' },
  VERBAL: { api: 'VERBAL', human: 'Mündlich' }
}
